var dynatraceLoader = function () {

  var publicMethods = {};

  var scriptInjected = false;

  publicMethods.init = function () {

    if (
      typeof dynatraceSettings == "undefined" ||
      !("source" in dynatraceSettings) ||
      !("config" in dynatraceSettings) ||
      !("cross" in dynatraceSettings) ||
      !("category" in dynatraceSettings)
    ) {

      return;

    }

    listen();

  };

  function listen() {

    document.addEventListener('consentSignalsUpdated', function (e) {

      var categories = e.detail.data.categories;

      for (var i = 0; i < categories.length; i++) {

        if (scriptInjected) break;

        (function (i) {

          if (
            categories[i].category === dynatraceSettings.category &&
            categories[i].checked
          ) {

            injectScript();

          }

        })(i);

      }

    });

  };

  function injectScript() {

    scriptInjected = true;

    var script = document.createElement('script');
    script.setAttribute('data-dtconfig', dynatraceSettings.config);
    script.setAttribute('crossorigin', dynatraceSettings.cross);
    script.src = dynatraceSettings.source;
    document.body.appendChild(script);

  };

  return publicMethods;

}();

 dynatraceLoader.init();
